import { OrganizationKeyName } from "../../../../model/Organization";

export const UPSERT_USER_VOUCHER_SUCCESS = "SHOP:UPSERT_USER_VOUCHER_SUCCESS";

export const upsertUserVoucherSuccessAction = (
  organization: OrganizationKeyName,
  id?: string
) => ({
  type: UPSERT_USER_VOUCHER_SUCCESS as typeof UPSERT_USER_VOUCHER_SUCCESS,
  organization,
  id,
});

export type UpsertUserVoucherSuccessAction = ReturnType<
  typeof upsertUserVoucherSuccessAction
>;
